import { Action } from 'redux';

import { UpdateAlerts } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IAlertListInfo } from '../models/IAlertInfo';

export interface UpdateAlertsAction extends Action, IAlertListInfo {}

export function updateAlertsAction(info: IAlertListInfo): UpdateAlertsAction {
  return {
    type: UpdateAlerts,
    alerts: info.alerts,
    total: info.total
  };
}

export const isUpdateAlertsAction = isActionFactory<UpdateAlertsAction>(UpdateAlerts);
